<!--
 * @Author: DY
 * @Date: 2024-11-19 18:40:39
 * @LastEditTime: 2025-03-17 16:06:53
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\components\selectList\index_table.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectList">
            <HeaderNav
                header-title="选择列表"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @search="onRefresh" @clear="onRefresh"></van-search>
                <div class="currencyTableStyle">
                    <div class="tableHeader">
                        <table>
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in parameter.headerList" :key="`tableHeader_${index}`" :style="{ width: item.width }">
                                        {{ item.name }}
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tablecontent">
                        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                            <van-list
                                v-model="loading"
                                :finished="finished"
                                finished-text="没有更多了"
                                @load="onLoad"
                            >
                                <table>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in listData"
                                            :key="`item_${index}`"
                                            :class="{'activeItem': selectIDs.includes(item[parameter.relationKey])}"
                                            @click="selectList(item)"
                                        >
                                            <td v-for="(k, j) in parameter.headerList" :key="`tableBody_${j}`" :style="{ width: k.width }">
                                                {{ item[k.code] }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </van-list>
                        </van-pull-refresh>
                    </div>
                </div>
                <footer class="currencyFooterStyle">
                    <button class="confirm" @click="confirmSelection">
                        确认选择
                    </button>
                </footer>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
import { HeaderNav } from '@/components/';
export default {
    name: 'select-list',
    mixins: [mixin_list],
    components: {
        HeaderNav,
    },
    data() {
        return {
            parameter: {
                sourcePath: '/home',
                type: 'radio',
                listCode: '',
                indexKey: 'PageIndex',
                sizeKey: 'PageSize',
                SearchKey: 'SearchKey',
                pageIndex: 1,
                pageSize: 15,
                initIndex: 1,
                requestUrl: '/basicplatform/tabledata',
                requestType: 'post',
                requestData: {},
                headerList: [],
                tableList: [],
                callbackDataKey: '',
                relationKey: 'id',
            },
            keyVal: '',
            isLoading: false,
            loading: false,
            finished: false,
            listData: [],
            selectChecked: [],
            selectIDs: [],
        };
    },
    filters: {},
    computed: {},
    watch: {},
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        this.initPage();
    },
    mounted() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ name: this.parameter.sourcePath });
        },
        async initPage() {
            this.parameter = Object.assign(this.parameter, this.$route.params);
        },
        onRefresh() {
            this.isLoading = false;
            this.finished = false;
            this.loading = true;
            this.parameter.pageIndex = JSON.parse(JSON.stringify(this.parameter.initIndex));
            this.listData = [];
            this.loadData();
        },
        onLoad() {
            this.loadData();
            this.parameter.pageIndex += 1;
        },
        async loadData() {
            if (this.parameter.requestType === 'post') {
                let requestData = {
                    code: this.parameter.listCode,
                    [this.parameter.indexKey]: this.parameter.isZero ? this.parameter.pageIndex - 1 : this.parameter.pageIndex,
                    [this.parameter.sizeKey]: this.parameter.pageSize,
                    cacheKey: this.cacheKey,
                    [this.parameter.SearchKey]: this.keyVal,
                };
                requestData = Object.assign(requestData, this.parameter.requestData);
                const res = await this.getListData_post(this.parameter.requestUrl, requestData);
                if (requestData[this.parameter.indexKey] === this.parameter.initIndex) {
                    this.listData = res.rows;
                } else {
                    this.listData.push(...res.rows);
                }
                if (res.total <= this.listData.length) {
                    this.finished = true;
                }
            } else if (this.parameter.requestType === 'get') {
                let requestUrl = this.parameter.requestUrl;
                if ((this.keyVal || '') !== '') {
                    if (this.parameter.requestUrl.includes('?')) {
                        requestUrl = `${this.parameter.requestUrl}&${this.parameter.SearchKey}=${this.keyVal}`;
                    } else {
                        requestUrl = `${this.parameter.requestUrl}?${this.parameter.SearchKey}=${this.keyVal}`;
                    }
                }
                const res = await this.getListData_get(requestUrl);
                this.listData = this.parameter.rowsKey && res ? res[this.parameter.rowsKey] : res;
                this.finished = true;
            }
            this.loading = false;
            this.isLoading = false;
        },
        selectList(item) {
            if (this.parameter.type === 'radio') {
                this.selectChecked = [item];
            } else if (this.parameter.type === 'checkbox') {
                const index = this.selectChecked.findIndex(k => k[this.parameter.relationKey] === item[this.parameter.relationKey]);
                if (index === -1) {
                    this.selectChecked.push(item);
                } else {
                    this.selectChecked.splice(index, 1);
                }
            }
            this.selectIDs = this.selectChecked.map(k => k[this.parameter.relationKey]);
        },
        confirmSelection() {
            if ((this.selectChecked || []).length > 0) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.parameter.sourcePath,
                    params: {
                        [this.parameter.callbackDataKey]: this.selectChecked,
                        [this.parameter.isParams]: this.$route.params[this.parameter.isParams],
                    },
                });
            } else {
                this.$toast.fail('请先选择列表数据！');
            }
        },
        getListData_post(requestUrl, requestData) {
            return this.$axios.$post(`/interfaceApi${requestUrl}`, requestData, { token: this.parameter.newsToken });
        },
        getListData_get(requestUrl) {
            return this.$axios.$get(`/interfaceApi${requestUrl}`, { token: this.parameter.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.selectList
    height 100%
    display: flex;
    flex-direction column
    section
        flex: 1
        height: 0
        .currencyTableStyle
            height calc(100% - 104rpx)
</style>
